import { render } from "./contactForm.vue?vue&type=template&id=bfb434ce"
import script from "./contactForm.vue?vue&type=script&lang=js"
export * from "./contactForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__